export interface AppSettings {
  timeouts: {
    wpscanTimeoutMs: number;
    nucleiTimeoutMs: number;
    httpxTimeoutMs: number;
    wpscanIdleTimeoutMs: number;
    nucleiIdleTimeoutMs: number;
  };
  scanners: {
    runHttpx: boolean;
    nucleiStats: boolean;
    nucleiValidate: boolean;
    wpscanAllocateTty: boolean;
    wpscanProfile: "stealth" | "thorough";
    wpscanApiToken: string;
    wpscanVulnDbEnrich: boolean;
    nucleiSeedUrls: boolean;
    nucleiSeedMaxUrls: number;
    blockAwareScanning: boolean;
    blockRetryDelayMs: number;
    blockRetryMaxAttempts: number;
  };
  openai: {
    enabled: boolean;
    apiKey: string;
    model: string;
  };
  vpn: {
    enabled: boolean;
    containerName: string;
    failClosed: boolean;
  };
}

export const defaultSettings: AppSettings = {
  timeouts: {
    wpscanTimeoutMs: 0,
    nucleiTimeoutMs: 0,
    httpxTimeoutMs: 5 * 60 * 1000,
    wpscanIdleTimeoutMs: 20 * 60 * 1000,
    nucleiIdleTimeoutMs: 15 * 60 * 1000,
  },
  scanners: {
    runHttpx: true,
    nucleiStats: true,
    nucleiValidate: false,
    wpscanAllocateTty: false,
    wpscanProfile: "stealth",
    wpscanApiToken: "",
    wpscanVulnDbEnrich: true,
    nucleiSeedUrls: true,
    nucleiSeedMaxUrls: 200,
    blockAwareScanning: true,
    blockRetryDelayMs: 120_000,
    blockRetryMaxAttempts: 1,
  },
  openai: {
    enabled: false,
    apiKey: "",
    model: "gpt-5-nano",
  },
  vpn: {
    enabled: false,
    containerName: "gluetun",
    failClosed: false,
  },
};
